import {
    Row,
    Col,
    Card,
    Table,
    Button,
    Modal,
    Form,
    Input,
    Tag,
    DatePicker,
    Select,
    InputNumber,
    Avatar,
    Upload
} from "antd";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import React, { useState, useContext, useEffect, useRef } from "react";
import { ToTopOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";
import useRequest from "../hooks/useRequest";
import { ShowToast, Severty } from "../helper/toast";
import Main from "../components/layout/Main";
import useDebounce from "../hooks/useDebounce";
import { UploadOutlined } from "@ant-design/icons";
import * as XLSX from "xlsx";
import moment from "moment";
import { uploadFile } from 'react-s3';
const { Option } = Select;
const { RangePicker } = DatePicker;
const Search = Input.Search;


const S3_BUCKET = 'sugamaya';
const REGION = 'us-east-1';
const ACCESS_KEY = 'AKIA6GBMIAPJULCPWKU5';
const SECRET_ACCESS_KEY = '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';

const config = {
    dirName: "taxi/banner",
    bucketName: S3_BUCKET,
    region: REGION,
    accessKeyId: ACCESS_KEY,
    secretAccessKey: SECRET_ACCESS_KEY,
}

function CarType() {
    const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
    const [searchText, setSearchText] = useState("");
    const [searchedColumn, setSearchedColumn] = useState("");
    const { request } = useRequest();
    const [list, setList] = useState([]);
    const [listExport, setListExport] = useState([]);
    const [loading, setLoading] = useState(false);
    const [refresh, setRefresh] = useState(false);
    const [visible, setVisible] = useState(false);
    const [subscriptionVisible, setSubscriptionVisible] = useState(false);
    const [visibleView, setVisibleView] = useState(false);
    const [changeAdvisor, setChangeAdvisor] = useState(false);
    const [provideSession, setProvideSession] = useState(false);
    const [selected, setSelected] = useState();
    const [viewData, setViewData] = useState();
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();
    const [filter, setFilter] = useState();
    const debouncedSearchText = useDebounce(searchText, 300);
    const searchInput = useRef(null);
    const navigate = useNavigate();
    const { confirm } = Modal;

    const handleExport = () => {
        const data =
            listExport &&
            listExport.length > 0 &&
            listExport.map((row) => ({
                Name: row.name,

            }));

        const workbook = XLSX.utils.book_new();
        const worksheet = XLSX.utils.json_to_sheet(data);
        XLSX.utils.book_append_sheet(workbook, worksheet, "Transaction Data");
        XLSX.writeFile(
            workbook,
            `${moment().milliseconds() +
            1000 * (moment().seconds() + 60 * 60) +
            "-USER"
            }.xlsx`
        );
    };
    const onSearch = (e) => {
        setSearchText(e.target.value);
        setPagination({ current: 1 });
    };

    const statusChange = (record) => {
        setLoading(true);
        request({
            url: `/admin/car-type/status-change/${record}?`,
            method: "PUT",
            onSuccess: (data) => {
                setRefresh((prev) => !prev);
                setLoading(false);
            },
            onError: (error) => {
                console.log(error);
                ShowToast(error, Severty.ERROR);
            },
        });
    };
    const showConfirm = (record) => {
        setTimeout(() => {
            confirm({
                icon: <ExclamationCircleOutlined />,
                content: <Button>Are you sure you want change the status ? </Button>,
                onOk() {
                    statusChange(record);
                },
                onCancel() {
                    console.log("Cancel");
                },
            });
        }, 5);
    };

    const columns = [
        {
            title: "Car Type Image",
            render: (_, { image }) => {
                return (
                    <Avatar.Group>
                        <Avatar
                            className="shape-avatar"
                            shape="square"
                            size={60}
                            src={image}
                        ></Avatar>
                    </Avatar.Group>
                )
            }
        },
        {
            title: "Name",
            render: (_, { name }) => {
                return <div>{name ? name : name}</div>;
            },
        },
        // {
        //     title: "Name",
        //     render: (_, { name }) => {
        //         return <div>{name ? name : name}</div>;
        //     },
        // },
        {
            title: "Number of seat/capacity",
            render: (_, { capacity }) => {
                return <div>{capacity ? capacity : 0}</div>;
            },
        },


        {
            title: "STATUS",
            key: "is_status",
            filters: [
                {
                    text: "Active",
                    value: true,
                },
                {
                    text: "InActive",
                    value: false,
                },
            ],
            onFilter: (value, record) => record.is_status === value,
            render: (_, { is_deleted, is_status, _id }) => {
                let color = is_deleted ? "red" : is_status ? "green" : "red";
                return (
                    <Tag
                        onClick={(e) => (!is_deleted ? showConfirm(_id) : null)}
                        color={color}
                        key={is_status}
                    >
                        {is_deleted ? "DELETED" : is_status ? "Active" : "Inactive"}
                    </Tag>
                );

            },
        },
        {
            title: "Registartion date",
            key: "created_at",
            dataIndex: "created_at",
            render: (_, { created_at }) => {
                return new Date(created_at).toLocaleDateString();
            },
        },
        {
            title: "Action",
            render: (_, record) => {
                return (
                    <>
                        <div className="cta_wrap">

                            <Button
                                onClick={() => {
                                    setSelected(record);
                                    setVisible(true);
                                }}
                            >
                                <i class="fa fa-light fa-pen"></i>
                                Edit
                            </Button>
                        </div>

                    </>
                );
            },
        },
    ];
    useEffect(() => {
        setLoading(true);
        fetchData(pagination);
    }, [refresh, debouncedSearchText, startDate, endDate]);

    const handleChange = (pagination, filters) => {
        setFilter(filters.is_active);
        fetchData(pagination, filters);
    };
    const fetchData = (pagination, filters) => {
        const filterActive = filters ? filters.is_status : null;
        request({
            url: `/admin/car-type/list?status=${filterActive ? filterActive.join(",") : ""
                }&page=${pagination ? pagination.current : 1}&limit=${pagination ? pagination.pageSize : 10
                }&search=${debouncedSearchText}&start_date=${startDate ? startDate : ""
                }&end_date=${endDate ? endDate : ""}`,
            method: "GET",
            onSuccess: (data) => {
                console.log(data)
                setLoading(false);
                setList(data.data.list.docs);
                setPagination((prev) => ({
                    current: pagination.current,
                    total: data.data.list.totalDocs,
                }));
            },
            onError: (error) => {
                console.log(error);
                ShowToast(error, Severty.ERROR);
            },
        });
    };
    const handleChangeDate = (e) => {
        setStartDate();
        setEndDate();
        if (e && e.length > 0) {
            setStartDate(moment(e[0]._d).format("YYYY-MM-DD"));
            setEndDate(moment(e[1]._d).format("YYYY-MM-DD"));
        }
    };
    // useEffect(() => {
    //     request({
    //         url: `/admin/car-type/get-list?status=${filter ? filter.join(",") : ""
    //             }&search=${debouncedSearchText}&start_date=${startDate ? startDate : ""
    //             }&end_date=${endDate ? endDate : ""}`,
    //         method: "GET",
    //         onSuccess: (data) => {
    //             console.log(data, "data");
    //             setLoading(false);
    //             setListExport(data.data.data);
    //         },
    //         onError: (error) => {
    //             console.log(error);
    //             ShowToast(error, Severty.ERROR);
    //         },
    //     });
    // }, [refresh, debouncedSearchText, startDate, endDate, filter]);
    return (
        <Main>
            <div className="tabled">
                <Row>
                    <Col xs="24" xl={24}>
                        <Card
                            bordered={false}
                            className="criclebox tablespace mb-24"
                            title="Car Type Management"
                            extra={
                                <>
                                    <Search
                                        size="large"
                                        onChange={onSearch}
                                        value={searchText}
                                        onPressEnter={onSearch}
                                    />
                                    <RangePicker onChange={handleChangeDate} />
                                    {/* <Button
                                        type="primary"
                                        icon={<ExportOutlined />}
                                        onClick={handleExport}
                                    >
                                        Export
                                    </Button> */}
                                    <Button
                                        onClick={(e) => {
                                            setVisible(true);
                                            setSearchText("");
                                        }}
                                    >
                                        Add Car Type
                                    </Button>
                                </>
                            }
                        >
                            <div className="table-responsive">
                                <Table
                                    loading={loading}
                                    columns={columns}
                                    dataSource={list}
                                    pagination={pagination}
                                    onChange={handleChange}
                                    className="ant-border-space"
                                />
                            </div>
                        </Card>
                    </Col>
                </Row>
            </div>
            {visible && (
                <AddFrom
                    show={visible}
                    hide={() => {
                        setSelected();
                        setVisible(false);
                        setSearchText("");
                    }}
                    data={selected}
                    refresh={() => setRefresh((prev) => !prev)}
                />
            )}

        </Main>
    );
}

const AddFrom = ({ show, hide, data, refresh }) => {

    const [form] = Form.useForm();
    const { request } = useRequest();

    const [loading, setLoading] = useState(false);

    const [file, setFile] = useState([]);

    const handleChange = async (event) => {
        setLoading(true)
        const { file } = event
        setFile([file])
        uploadFile(file, config)
            .then(data => {
                const fileData = {
                    uid: file.uid,
                    name: file.name,
                    status: 'done',
                    url: data.location,
                    thumbUrl: data.location,
                }
                setFile([fileData])
                setLoading(false)
                console.log(data)
            }

            )
            .catch(err => console.error(err))
    };
    useEffect(() => {
        if (!data) return;
        form.setFieldsValue({ ...data });
        const file = {
            url: data.image
        };
        data.image && setFile([file])

    }, [data]);

    const onCreate = (values) => {
        const { name, capacity, price } = values;
        const payload = {};

        setLoading(true);

        payload.name = name;
        payload.price = price;
        payload.capacity = capacity;
        payload.image = file.length > 0 ? file[0].url : ''

        request({
            url: `${data
                ? `/admin/car-type/edit/${data._id}`
                : `/admin/car-type/add`
                }`,
            method: `${data ? "PUT" : "POST"}`,
            data: payload,
            onSuccess: (data) => {
                setLoading(false);
                if (data.status) {
                    ShowToast(data.message, Severty.SUCCESS);
                    hide();
                    refresh();
                    // hide()
                } else {
                    ShowToast(data.message, Severty.ERROR);
                }
            },
            onError: (error) => {
                ShowToast(error.response.data.message, Severty.ERROR);
                // console.log(error.response.data, "Error")
                setLoading(false);
            },
            // onErrorSubmit: (data) => {
            //   console.log(data)
            // }
        });
        // console.log(values)
    };

    return (
        <Modal
            visible={show}
            title={`${data ? "Edit Car Type" : "Car Type"} `}
            okText="Ok"
            onCancel={hide}
            okButtonProps={{
                form: "create",
                htmlType: "submit",
                loading: loading,
            }}
        >
            <Form id="create" form={form} onFinish={onCreate} layout="vertical">
                <Row>
                    <Col span={24}>
                        <Form.Item
                            label="Car Type"
                            name="name"
                            rules={[
                                { required: true, message: "Please input the name!" },
                                {
                                    pattern: new RegExp(/^[a-zA-Z ]*$/),
                                    message: "Only Alphabetic Characters Allowed",
                                },
                            ]}
                        >
                            <Input />
                        </Form.Item>
                    </Col>

                    <Col span={24}>
                        <Form.Item
                            label="Number of seats/capacity"
                            name="capacity"
                            rules={[
                                { required: true, message: "Please input the Capacity!" },

                            ]}
                        >
                            <InputNumber />
                        </Form.Item>
                    </Col>

                    <Col span={24}>
                        <Form.Item
                            label="Price ($) (Per Mile)"
                            name="price"
                            rules={[
                                { required: true, message: "Please input the price!" },

                            ]}
                        >
                            <InputNumber />
                        </Form.Item>
                    </Col>

                </Row>
                <Col span={24}>
                    <Form.Item

                        label="Car Type Image"
                    >


                        <Upload
                            listType="picture"
                            maxCount={1}
                            customRequest={handleChange}
                            onRemove={(e) => setFile([])}
                            fileList={file}
                        >
                            {file.length > 0 ? null : <Button icon={<UploadOutlined />}>Upload</Button>}
                        </Upload>
                    </Form.Item>
                </Col>
            </Form>
        </Modal>
    );
};






export default CarType;
